import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import { itemMani } from "../../tool";
import { drawCommon } from "../drawCommon"

/**
* ポスカ用の、移動・リサイズ・回転を行う基本エディター
* @summary 選択アイテムの編集条件に応じて、リサイズ・観点のハンドルを表示し、各操作を実施します。
*/
export class poscaMoveEditor extends sonbp.listener.editor.moveEditor {

	protected _ifdto: ifbase.ifDto;

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super();

		this._ifdto = ifdto;
	}

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * キーダウン処理
	 * @summary キー操作無効
	 * @override
	 */
	public evKeydown(e: KeyboardEvent): sonbp.type.listerResult {
		return new sonbp.type.listerResult();
	}

	// -----------------------------------------------
	// Properties（内部変数）
	// -----------------------------------------------

	// -----------------------
	// 描画機能 関数
	// -----------------------

	// -----------------------------------------------
	// Methods（内部関数）
	// -----------------------------------------------

	/**
	 * 編集対象情報の取得
	 * @override
	 */
	protected getMovers(): poscaMovers {

		if (this._select.items.length == 0) return null;

		var mvs: poscaMovers = new poscaMovers(this._ifdto, this._v, this._select.pageIndex, this._select.layerIdxs, this._select.items[0]._apply_pmatrix);

		for (var i = 0; i < this._select.items.length; i++) {
			mvs.members.push(new sonbp.listener.editor.vitem(this._select.items[i]));
		}

		return mvs;
	}

	/**
	 * 選択矩形の描画
	 * @override
	 */
	protected drawRect(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], fill: boolean = false, stroke: boolean = true): void {

		drawCommon.drawRect(this._ifdto, ctx, points, fill, stroke);
	}

	/**
	 * 移動ハンドルの描画
	 * @override
	 */
	protected drawMovePoint(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isMoveNg: boolean): void {
		//nop.
	}

	/**
	 * リサイズハンドルの描画
	 * @override
	 */
	protected drawResizePoint(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isResizeNg: boolean, isAspectNg: boolean): void {

		if (!this.hasResizePoint()) return;
		drawCommon.drawResizePoint(this._ifdto, ctx, points, base_points, out_points, isResizeNg, isAspectNg);
	}

	/**
	 * 回転ハンドルの描画
	 * @override
	 */
	protected drawRotatePoint(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isRotateNg: boolean): void {

		if (!this.hasRotatePoint()) return;
		drawCommon.drawRotatePoint(this._ifdto, ctx, points, base_points, out_points, isRotateNg);
	}

	protected getResizeHandle(docPt: sonbp.type.point, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], resizeNg: boolean, aspectNg: boolean): sonbp.listener.editor.handle {

		if (this._ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードはアイコン操作させない
			return null;
		}

		let sz = this._v._stl.editHandleSize / this._v._dm.scaleRate;

		let isV = sonbp.util.c2d.isVHForPoints(true, points, 3);
		let isH = sonbp.util.c2d.isVHForPoints(false, points, 3);

		if (isV || isH) return null;

		if (!resizeNg) {

			let chks = [2];

			for (let i = 0; i < chks.length; i++) {
				let pt = ifbase.util.getIconPoint(this._ifdto, points, chks[i], sz);
				if (this.checkHandle(pt, sz * 3, docPt)) {
					return { type: 2, ptIdx: chks[i] };
				}
			}
		}

		return null
	}
	protected getRotateHandle(docPt: sonbp.type.point, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], rotateNg: boolean): sonbp.listener.editor.handle {

		if (this._ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードはアイコン操作させない
			return null;
		}

		if (!rotateNg) {
			let sz = this._v._stl.editHandleSize / this._v._dm.scaleRate;

			let chks = [0];

			for (let i = 0; i < chks.length; i++) {
				let pt = ifbase.util.getIconPoint(this._ifdto, points, chks[i], sz);
				if (this.checkHandle(pt, sz * 3, docPt)) {
					return { type: 3, ptIdx: chks[i] };
				}
			}
		}

		return null
	}

	// -----------------------------------------------
	// Methods（内部アクセス用メソッド）
	// -----------------------------------------------

}

/**
 * 編集対象まとめクラス
 * ※ 業務仕様の移動制限を加味。
 */
export class poscaMovers extends sonbp.listener.editor.movers {

	protected _ifdto: ifbase.ifDto;

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto, v: sonbp.view, apply_pageIdx: number, apply_layerIdxs: number[], apply_pmatrix: number[]) {
		super(v, apply_pageIdx, apply_layerIdxs, apply_pmatrix);

		this._ifdto = ifdto;
	}

	/**
	 * 移動シミュレーション
	 * @override
	 */
	public move(spt: sonbp.type.point, ept: sonbp.type.point, func: (itemRefs: sonbp.type.itemRefInfo[], dx: number, dy: number) => void = null): void {

		var x = ept.x - spt.x;
		var y = ept.y - spt.y;

		// マトリックス逆変換(アイテムの移動量は関係なし)
		let mat = this.apply_pmatrix;
		mat = sonbp.util.c2d.matrixInverse(mat);
		mat[4] = 0;
		mat[5] = 0;

		let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(x, y), mat);

		if (func != null) {

			func(this.correctRefs(), v.x, v.y);

		} else {

			for (var i = 0; i < this.members.length; i++) {

				this.members[i].init();
				this.members[i].move(v.x, v.y);
			}
		}
	}

	/**
	 * 拡大シミュレーション
	 * @override
	 */
	public scale(ptIdx: number, spt: sonbp.type.point, ept: sonbp.type.point, aspect: boolean, func: (itemRefs: sonbp.type.itemRefInfo[], sx: number, sy: number, ptIdx: number, oppsitIdx: number) => void = null): void {

		var x = ept.x - spt.x;
		var y = ept.y - spt.y;

		x *= 2;
		y *= 2;

		// マトリックス逆変換(アイテムの移動量は関係なし)
		let mat = this.apply_pmatrix;
		mat = sonbp.util.c2d.matrixInverse(mat);
		mat[4] = 0;
		mat[5] = 0;

		let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(x, y), mat);

		this.init();

		// 一つの場合

		if (this.members.length == 1) {

			var pts = this.members[0].getPoints();

			// ベクトルを変換
			var rad = sonbp.util.c2d.getRadian(pts[4], pts[5]);
			var vv = sonbp.util.c2d.getPointWithRotate(new sonbp.type.point(0, 0), v, -rad);

			// ベクトル調整
			if (ptIdx % 3 == 0) vv.x *= -1;
			else if (ptIdx % 3 == 1) vv.x = 1;
			if (ptIdx <= 2) vv.y *= -1;
			else if (3 <= ptIdx && ptIdx <= 5) vv.y = 1;

			// スケールを算定
			var w = sonbp.util.c2d.getDistance(pts[3], pts[5]);
			var h = sonbp.util.c2d.getDistance(pts[1], pts[7]);
			var sx = (w + vv.x) / w;
			var sy = (h + vv.y) / h;

			// スケールを調整（アスペクト比固定がある場合に固定する）
			if (this.mode(sonbp.constant.editModeType.ASPECT_NG) || aspect) {
				if (sx == 1) sx = sy;
				else if (sy == 1) sy = sx;
				else if (sx > sy) sx = sy;
				else sy = sx;
			}

			//拡縮制限チェック
			let s = {
				sx: sx,
				sy: sy
			};
			let vi = this.members[0];
			itemMani.chkScaleOver(this._ifdto, vi.item, vi.apply_matrix, vi.apply_points, s);
			sx = s.sx;
			sy = s.sy;

			// 処理

			var ptIdx = 4;		//左右に広がるので中央固定
			var oppsitIdx = 8 - ptIdx;

			if (func != null) {

				func(this.correctRefs(), sx, sy, ptIdx, oppsitIdx);

			} else {

				this.members[0].scale(sx, sy);
				var pts2 = this.members[0].getPoints();
				this.members[0].move(pts[oppsitIdx].x - pts2[oppsitIdx].x, pts[oppsitIdx].y - pts2[oppsitIdx].y);
			}

		}
		else {

			//ポスカは複数選択不可なので実装不要。
		}
	}

	/**
	 * 回転シミュレーション
	 * @override
	 */
	public rotate(spt: sonbp.type.point, ept: sonbp.type.point, func: (itemRefs: sonbp.type.itemRefInfo[], rad: number, cpt: sonbp.type.point) => void = null): void {

		this.init();

		// 回転の中心
		var cpt = this.getPointsOfSummary().summary[4];

		// 角度
		var srad = sonbp.util.c2d.getRadian(cpt, spt);
		var erad = sonbp.util.c2d.getRadian(cpt, ept);
		var rad = erad - srad;

		if (func != null) {

			// マトリックス逆変換
			let mat = this.apply_pmatrix;
			mat = sonbp.util.c2d.matrixInverse(mat);

			cpt = sonbp.util.c2d.setPointMatrix(cpt, mat);

			func(this.correctRefs(), rad, cpt);

		} else {

			this.releaseSummary();
			this.saveSummary();

			for (var i = 0; i < this.members.length; i++) {

				this.members[i].rotate(rad);

				var pt = this.members[i].getPoints()[4];
				var newpt = sonbp.util.c2d.getPointWithRotate(cpt, pt, rad);

				this.members[i].move(newpt.x - pt.x, newpt.y - pt.y);
			}

			// サマリを回転
			this._tmpSummary[0] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[0], rad);
			this._tmpSummary[2] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[2], rad);
			this._tmpSummary[6] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[6], rad);
			this._tmpSummary[8] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[8], rad);
		}
	}

	/**
	 * ２点指示による拡大・回転シミュレーション
	 * @override
	 */
	public scaleRotate(
		spt0: sonbp.type.point, spt1: sonbp.type.point,
		ept0: sonbp.type.point, ept1: sonbp.type.point,
		doScale: boolean, doRotate: boolean,
		func: (itemRefs: sonbp.type.itemRefInfo[], doScale: boolean, doRotate: boolean, cpt: sonbp.type.point, scale: number, rad: number) => void = null
	): void {

		this.init();

		// 拡大率

		const sd = sonbp.util.c2d.getDistance(spt0, spt1);
		const ed = sonbp.util.c2d.getDistance(ept0, ept1);
		let scale = ed / sd

		//ffposca
		{
			//拡縮制限チェック
			let s = {
				sx: scale,
				sy: scale
			};
			let vi = this.members[0];
			itemMani.chkScaleOver(this._ifdto, vi.item, vi.apply_matrix, vi.apply_points, s);
			scale = s.sx;
		}

		// 回転角度

		const srad = sonbp.util.c2d.getRadian(spt0, spt1);
		const erad = sonbp.util.c2d.getRadian(ept0, ept1);
		let rad = erad - srad;

		// 操作の中心

		const cpt0 = this.getPointsOfSummary().summary[4];

		if (func) {
			func(this.correctRefs(), doScale, doRotate, cpt0, scale, rad);
			return;
		}

		if (doScale) {

			if (this.members.length == 1) {

				this.members[0].scale(scale, scale);
				var cpt1 = this.members[0].getPoints()[4];
				this.members[0].move(cpt0.x - cpt1.x, cpt0.y - cpt1.y);

			} else {

				//ポスカは複数選択不可なので実装不要。
			}
		}

		if (doRotate) {

			this.releaseSummary();
			this.saveSummary();

			for (let i = 0; i < this.members.length; i++) {

				this.members[i].rotate(rad);
				let pt = this.members[i].getPoints()[4];
				let newpt = sonbp.util.c2d.getPointWithRotate(cpt0, pt, rad);
				this.members[i].move(newpt.x - pt.x, newpt.y - pt.y);
			}

			// サマリを回転
			this._tmpSummary[0] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[0], rad);
			this._tmpSummary[2] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[2], rad);
			this._tmpSummary[6] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[6], rad);
			this._tmpSummary[8] = sonbp.util.c2d.getPointWithRotate(this._tmpSummary[4], this._tmpSummary[8], rad);
		}
	}
}
